import { z } from "zod";
import { RequestStateTypeEnumSchema } from "../Enums/RequestStateTypeEnum";

export const RequestStateDtoSchema = z.object({
    requestStateTypeId: RequestStateTypeEnumSchema,
    name: z.string().nullish(),
    icon: z.string().nullish(),
    iconColor: z.string().nullish(),
    description: z.string().nullish(),
    isFinishingState: z.boolean(),
    eventDate: z.string(),
});

export type RequestStateDto = z.infer<typeof RequestStateDtoSchema>;